import { render, staticRenderFns } from "./ApplyTicketWhatsappTemplateModal.vue?vue&type=template&id=44c2da3a&"
import script from "./ApplyTicketWhatsappTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ApplyTicketWhatsappTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports